import { AuthPayload } from '../@types/auth';

export const decodePayload = (token: string): AuthPayload => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(decodeURIComponent(escape(window.atob(base64))));
};
